<template>
  <NavbarTwo />

  <!-- Page hero -->
  <div class="pricing-page-hero">
    <div class="container text-center">
      <span class="top-title">PRICING PLANS</span>
      <h1>Choose Your Plan</h1>
      <p>No contracts. No hidden fees. Cancel any time.</p>
    </div>
  </div>

  <!-- Pricing cards — reuses the same live component -->
  <PricingPlans />

  <!-- Features reminder -->
  <div class="pricing-features-strip">
    <div class="container">
      <div class="pf-grid">
        <div class="pf-item">
          <i class="ti ti-device-tv"></i>
          <span>25,000+ Channels</span>
        </div>
        <div class="pf-item">
          <i class="ti ti-4k"></i>
          <span>4K & FHD Quality</span>
        </div>
        <div class="pf-item">
          <i class="ti ti-devices"></i>
          <span>All Devices</span>
        </div>
        <div class="pf-item">
          <i class="ti ti-headset"></i>
          <span>24/7 Support</span>
        </div>
        <div class="pf-item">
          <i class="ti ti-shield-check"></i>
          <span>Money-Back Guarantee</span>
        </div>
      </div>
    </div>
  </div>

  <MainFooter
    class="bg-secondary bg-img"
    :style="{ backgroundImage: `url(${bgImage})` }"
  />
  <CopyRight />
</template>

<script lang="ts">
import { defineComponent, onBeforeUnmount, onMounted } from "vue";
import { useSeo } from "@/composables/useSeo";
import NavbarTwo from "@/components/Layouts/NavbarTwo.vue";
import PricingPlans from "@/components/IPTVService/PricingPlans.vue";
import MainFooter from "@/components/Layouts/MainFooter.vue";
import CopyRight from "@/components/Layouts/CopyRight.vue";

export default defineComponent({
  name: "PricingPage",
  components: { NavbarTwo, PricingPlans, MainFooter, CopyRight },
  setup() {
    useSeo({
      title: "IPTV Pricing Plans — From $10/Month",
      description: "Choose your goplayTv IPTV plan. Watch World Cup 2026, sports, movies and 25,000+ channels in HD/4K. Plans from $10/month with instant activation.",
      url: "/pricing",
      keywords: "IPTV pricing, cheap IPTV subscription, World Cup 2026 IPTV, HD TV plans, goplayTv plans",
    });
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const bgImage = require("@/assets/images/footer-shape.png");

    onMounted(() => {
      document.body.classList.add("bg-gondola");
    });
    onBeforeUnmount(() => {
      document.body.classList.remove("bg-gondola");
    });

    return { bgImage };
  },
});
</script>

<style scoped>
.pricing-page-hero {
  min-height: 280px;
  background: linear-gradient(180deg, rgba(10,1,2,0.0) 0%, rgba(10,1,2,0.92) 100%),
              #0a0102;
  display: flex;
  align-items: flex-end;
  padding: 120px 0 0;
  position: relative;
}

.pricing-page-hero .top-title {
  color: #c90e0e;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 3px;
  display: block;
  margin-bottom: 0.75rem;
}

.pricing-page-hero h1 {
  color: #fff;
  font-size: clamp(2rem, 4vw, 3.5rem);
  font-weight: 800;
  margin-bottom: 0.75rem;
  line-height: 1.15;
}

.pricing-page-hero p {
  color: #c0c0c0;
  font-size: 1rem;
  margin-bottom: 0;
}

/* Features strip */
.pricing-features-strip {
  background: #201516;
  border-top: 1px solid #3a2526;
  border-bottom: 1px solid #3a2526;
  padding: 1.25rem 0;
}

.pf-grid {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2.5rem;
  flex-wrap: wrap;
}

.pf-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #c0c0c0;
  font-size: 0.9rem;
  font-weight: 600;
  white-space: nowrap;
}

.pf-item i {
  color: #c90e0e;
  font-size: 1.2rem;
}
</style>
